var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFloorPlanIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 0.125H1.25C0.63125 0.125 0.125 0.63125 0.125 1.25V14.75C0.125 15.3687 0.63125 15.875 1.25 15.875H9.6875V14.75C9.6875 13.175 10.925 11.9375 12.5 11.9375V10.8125C10.3062 10.8125 8.5625 12.5562 8.5625 14.75H6.875V12.5H5.75V14.75H1.25V1.25H5.75V9.125H6.875V6.3125H9.125V5.1875H6.875V1.25H14.75V5.1875H12.5V6.3125H14.75V14.75H12.5V15.875H14.75C15.3687 15.875 15.875 15.3687 15.875 14.75V1.25C15.875 0.63125 15.3687 0.125 14.75 0.125Z",
    fill: "#CECCCA"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFloorPlanIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/floorPlan_icon.2c35d6dc.svg";
export { ForwardRef as ReactComponent };